/**
 * Ark Tiles — free sample order cap (theme UX backup).
 *
 * Hard maximum is 5 sample units per order. Quantities are summed across every
 * cart line for the sample product (multiple "Sample of" properties are separate
 * lines of the same variant). This script caps quantity inputs and refuses adds
 * that would pass 5. It does not change the £0 sample price or the £4.99
 * delivery rate.
 *
 * Checkout click interception removed (hotfix 26 Oct 2026): it could block
 * legitimate Checkout / Shop Pay clicks. Cap remains on cart add/change/update
 * only. Server checkout is not locked (Shopify plan; Function not deployed).
 */
(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) root.ArkSampleCap = api;
  if (typeof document !== 'undefined') api.install();
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  var MAX = 5;
  var MESSAGE = 'You can order up to 5 free samples per order';
  var PRODUCT_ID = '16352252035417';
  var VARIANT_ID = '58278074548569';
  var SKU = 'sample';
  var HANDLE = 'sample';

  function digits(id) {
    if (id == null || id === '') return '';
    var match = String(id).match(/(\d+)\s*$/);
    return match ? match[1] : '';
  }

  function text(value) {
    return String(value == null ? '' : value).trim().toLowerCase();
  }

  function productDigits(item) {
    if (!item) return '';
    if (item.product_id != null) return digits(item.product_id);
    if (item.productId != null) return digits(item.productId);
    if (item.product && item.product.id != null) return digits(item.product.id);
    return '';
  }

  function variantDigits(item) {
    if (!item) return '';
    if (item.variant_id != null) return digits(item.variant_id);
    if (item.variantId != null) return digits(item.variantId);
    if (item.id != null && String(item.id).indexOf('CartLine') === -1) return digits(item.id);
    return '';
  }

  function skuOf(item) {
    if (!item) return '';
    if (item.sku != null && item.sku !== '') return text(item.sku);
    if (item.variant_sku != null) return text(item.variant_sku);
    if (item.variant && item.variant.sku != null) return text(item.variant.sku);
    return '';
  }

  function handleOf(item) {
    if (!item) return '';
    if (item.handle != null && item.handle !== '') return text(item.handle);
    if (item.product_handle != null) return text(item.product_handle);
    if (item.product && item.product.handle != null) return text(item.product.handle);
    return '';
  }

  function isSampleLine(item) {
    if (!item || typeof item !== 'object') return false;
    return (
      productDigits(item) === PRODUCT_ID ||
      variantDigits(item) === VARIANT_ID ||
      skuOf(item) === SKU ||
      handleOf(item) === HANDLE
    );
  }

  function lineQty(item) {
    var qty = Number(item && item.quantity);
    if (!isFinite(qty) || qty < 0) return 0;
    return qty;
  }

  function sumSampleQty(items) {
    var total = 0;
    var list = items || [];
    for (var i = 0; i < list.length; i++) {
      if (isSampleLine(list[i])) total += lineQty(list[i]);
    }
    return total;
  }

  function remaining(items) {
    return Math.max(0, MAX - sumSampleQty(items));
  }

  /**
   * Absolute max for one cart line so the order total cannot pass 5.
   * max = 5 - (sample units on every other line).
   */
  function lineInputMax(items, thisQty) {
    var current = Number(thisQty);
    if (!isFinite(current) || current < 0) current = 0;
    var others = sumSampleQty(items) - current;
    if (others < 0) others = 0;
    return Math.max(0, MAX - others);
  }

  function evaluateAdd(items, addQty) {
    var add = Number(addQty);
    if (!isFinite(add) || add <= 0) return { ok: true, message: '' };
    var have = sumSampleQty(items);
    if (have + add > MAX) return { ok: false, message: MESSAGE, have: have, add: add };
    return { ok: true, message: '', have: have, add: add };
  }

  function addEntryIsSample(entry, context) {
    if (isSampleLine(entry)) return true;
    var id = entry && (entry.id != null ? entry.id : entry.variant_id);
    if (!context || !context.onSamplePage || !context.pageVariantId) return false;
    return digits(id) !== '' && digits(id) === digits(context.pageVariantId);
  }

  function entryQty(entry) {
    var qty = Number(entry && entry.quantity);
    if (!isFinite(qty) || qty <= 0) return 1;
    return qty;
  }

  function sampleQtyInAdd(body, context) {
    if (!body || typeof body !== 'object') return 0;
    if (Array.isArray(body.items)) {
      return body.items.reduce(function (sum, entry) {
        return addEntryIsSample(entry, context) ? sum + entryQty(entry) : sum;
      }, 0);
    }
    if (body.id == null && body.variant_id == null && body.product_id == null && !body.sku && !body.handle) {
      return 0;
    }
    return addEntryIsSample(body, context) ? entryQty(body) : 0;
  }

  function projectChange(items, body) {
    if (!body || body.quantity == null) return null;
    var nextQty = Number(body.quantity);
    if (!isFinite(nextQty) || nextQty < 0) return null;
    var list = items || [];
    var index = -1;
    if (body.line != null && body.line !== '') index = Number(body.line) - 1;
    else if (body.id != null) {
      var key = String(body.id);
      index = list.findIndex(function (item) {
        return String(item.key) === key || variantDigits(item) === digits(key);
      });
    }
    if (index < 0 || !list[index]) return null;
    if (!isSampleLine(list[index])) return sumSampleQty(list);
    return sumSampleQty(
      list.map(function (item, i) {
        return i === index ? Object.assign({}, item, { quantity: nextQty }) : item;
      })
    );
  }

  function projectUpdate(items, updates) {
    var list = items || [];
    if (Array.isArray(updates)) {
      return sumSampleQty(
        list.map(function (item, i) {
          if (updates[i] == null || updates[i] === '') return item;
          var qty = Number(updates[i]);
          if (!isFinite(qty) || qty < 0) return item;
          return Object.assign({}, item, { quantity: qty });
        })
      );
    }
    if (!updates || typeof updates !== 'object') return null;
    var used = {};
    var next = list.map(function (item) {
      return Object.assign({}, item);
    });
    Object.keys(updates).forEach(function (key) {
      var qty = Number(updates[key]);
      if (!isFinite(qty) || qty < 0) return;
      var index = next.findIndex(function (item, i) {
        if (used[i]) return false;
        return String(item.key) === key || variantDigits(item) === digits(key.split(':')[0]);
      });
      if (index < 0) return;
      used[index] = true;
      next[index].quantity = qty;
    });
    return sumSampleQty(next);
  }

  /**
   * @param {Array} items Current cart.js items
   * @param {{kind: string, body: object, context?: object}} action
   * @returns {{allow: boolean, ignore: boolean, message?: string, added?: number, projected?: number}}
   */
  function decideCartMutation(items, action) {
    var kind = action && action.kind;
    var body = (action && action.body) || {};
    var context = (action && action.context) || {};
    var have = sumSampleQty(items);

    if (kind === 'add') {
      var addQty = sampleQtyInAdd(body, context);
      if (addQty <= 0) return { allow: true, ignore: true };
      var added = evaluateAdd(items, addQty);
      if (!added.ok) return { allow: false, ignore: false, message: added.message, added: 0 };
      return { allow: true, ignore: false, added: addQty, projected: have + addQty };
    }

    if (kind === 'change') {
      var changed = projectChange(items, body);
      if (changed == null) return { allow: true, ignore: true };
      if (changed > MAX && changed > have) {
        return { allow: false, ignore: false, message: MESSAGE, projected: changed };
      }
      return { allow: true, ignore: changed === have, projected: changed };
    }

    if (kind === 'update') {
      if (!body.updates) return { allow: true, ignore: true };
      var projected = projectUpdate(items, body.updates);
      if (projected == null) return { allow: true, ignore: true };
      if (projected > MAX && projected > have) {
        return { allow: false, ignore: false, message: MESSAGE, projected: projected };
      }
      return { allow: true, ignore: projected === have, projected: projected };
    }

    return { allow: true, ignore: true };
  }

  var state = {
    knownCartQty: null,
    items: [],
  };

  function cartJsUrl() {
    var base = '/cart';
    if (root.Theme && root.Theme.routes && root.Theme.routes.cart_url) base = root.Theme.routes.cart_url;
    else if (root.Shopify && root.Shopify.routes && root.Shopify.routes.root) {
      base = String(root.Shopify.routes.root).replace(/\/?$/, '/') + 'cart';
    }
    return base + '.js';
  }

  function mutationKind(url) {
    try {
      var path = new URL(url, root.location ? root.location.origin : 'https://arktiles.co.uk').pathname;
      var match = path.match(/\/cart\/(add|change|update)(?:\.js)?$/);
      return match ? match[1] : null;
    } catch (error) {
      return null;
    }
  }

  function parseBody(body) {
    if (body == null) return null;
    if (typeof body === 'string') {
      var trimmed = body.trim();
      if (!trimmed) return null;
      if (trimmed.charAt(0) === '{' || trimmed.charAt(0) === '[') {
        try {
          return JSON.parse(trimmed);
        } catch (error) {
          return null;
        }
      }
      return paramsToObject(new URLSearchParams(trimmed));
    }
    if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) return paramsToObject(body);
    if (typeof FormData !== 'undefined' && body instanceof FormData) return paramsToObject(body);
    return null;
  }

  function paramsToObject(source) {
    var obj = {};
    var items = [];
    source.forEach(function (value, key) {
      var indexed = key.match(/^items\[(\d+)\]\[(\w+)\]$/);
      if (indexed) {
        var index = Number(indexed[1]);
        items[index] = items[index] || {};
        items[index][indexed[2]] = value;
        return;
      }
      if (key === 'quantity' || key === 'line') obj[key] = value;
      else obj[key] = value;
    });
    if (items.length) obj.items = items.filter(Boolean);
    return obj;
  }

  function pageContext() {
    var form = document.querySelector('product-form-component[data-ark-sample-product]');
    var onSamplePage = /\/products\/sample(?:[/?#]|$)/.test(location.pathname) || !!form;
    var variantInput = form && form.querySelector('input[name="id"]');
    return {
      onSamplePage: onSamplePage,
      pageVariantId: variantInput ? variantInput.value : VARIANT_ID,
    };
  }

  function showMessage(anchor) {
    var note = document.querySelector('[data-ark-sample-cap-note]');
    if (!note) {
      note = document.createElement('div');
      note.setAttribute('data-ark-sample-cap-note', '');
      note.setAttribute('role', 'alert');
      note.className = 'ark-sample-cap-note';
    }
    note.textContent = MESSAGE;
    if (anchor && anchor.insertAdjacentElement) anchor.insertAdjacentElement('afterend', note);
    else {
      var host =
        document.querySelector('cart-drawer-component .cart-drawer__inner') ||
        document.querySelector('cart-items-component') ||
        document.querySelector('#MainContent') ||
        document.body;
      if (host.firstChild) host.insertBefore(note, host.firstChild);
      else host.appendChild(note);
    }
    return note;
  }

  function applyInputCaps(items) {
    var total = sumSampleQty(items);
    state.knownCartQty = total;
    state.items = items || [];

    document.querySelectorAll('[data-ark-sample]').forEach(function (el) {
      var input = el.querySelector('input[name="updates[]"], input[name="quantity"]');
      if (!input) return;
      var cartLine = el.tagName === 'CART-QUANTITY-SELECTOR-COMPONENT' || input.name === 'updates[]';
      if (cartLine) {
        input.max = String(lineInputMax(items, Number(input.value) || 0));
        if (typeof el.updateButtonStates === 'function') el.updateButtonStates();
      } else {
        input.max = String(MAX);
        input.setAttribute('data-cart-quantity', String(total));
        if (typeof el.updateCartQuantity === 'function') el.updateCartQuantity();
        else if (typeof el.updateButtonStates === 'function') el.updateButtonStates();
      }
    });

    document.querySelectorAll('[data-ark-sample-cap]').forEach(function (widget) {
      widget.setAttribute('data-ark-sample-in-cart', String(total));
      var visible = widget.querySelector('[data-qty], [data-boxes]');
      if (!visible) return;
      var room = Math.max(0, MAX - total);
      visible.max = String(room);
    });

    document.dispatchEvent(new CustomEvent('ark:sample-cap', { detail: { quantity: total, message: MESSAGE } }));

    if (total > MAX && /\/cart(?:[/?#]|$)/.test(location.pathname)) showMessage(null);
  }

  function refusedResponse() {
    return new Response(
      JSON.stringify({
        status: 422,
        message: MESSAGE,
        description: MESSAGE,
        errors: MESSAGE,
      }),
      { status: 422, headers: { 'Content-Type': 'application/json' } }
    );
  }

  function anchorForRefusal() {
    return (
      document.querySelector('[data-ark-sample-cap]') ||
      document.querySelector('product-form-component[data-ark-sample-product] [name="add"]') ||
      document.querySelector('#checkout') ||
      document.querySelector('[data-ark-sample]')
    );
  }

  function install() {
    if (install.done || typeof window === 'undefined' || !window.fetch) return;
    install.done = true;

    if (!document.getElementById('ark-sample-cap-css')) {
      var style = document.createElement('style');
      style.id = 'ark-sample-cap-css';
      style.textContent =
        '.ark-sample-cap-note{margin:8px 0 12px;font-size:13px;line-height:1.45;color:#7a4a12;background:#fff6e5;border:1px solid #f0dcb0;border-radius:8px;padding:9px 11px}';
      document.head.appendChild(style);
    }

    var originalFetch = window.fetch.bind(window);
    var tail = Promise.resolve();

    function withLock(fn) {
      var run = tail.then(fn, fn);
      tail = run.then(
        function () {},
        function () {}
      );
      return run;
    }

    function needsCheck(kind, body, context) {
      if (kind === 'add') return sampleQtyInAdd(body, context) > 0;
      if (kind === 'change') {
        if (!body || body.line == null) return true;
        var inputs = document.querySelectorAll('[data-cart-line="' + Number(body.line) + '"]');
        if (!inputs.length) return true;
        return Array.prototype.some.call(inputs, function (input) {
          return !!input.closest('[data-ark-sample]');
        });
      }
      if (kind === 'update') {
        if (!body || body.updates == null) return false;
        if (Array.isArray(body.updates)) return !!document.querySelector('[data-ark-sample]');
        return Object.keys(body.updates).some(function (key) {
          return digits(String(key).split(':')[0]) === VARIANT_ID;
        });
      }
      return false;
    }

    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : input && input.url;
      var kind = mutationKind(url || '');
      var method = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
      if (!kind || method === 'GET' || method === 'HEAD') return originalFetch(input, init);

      var body = parseBody(init && init.body);
      var context = pageContext();
      if (!needsCheck(kind, body, context)) return originalFetch(input, init);

      return withLock(function () {
        return originalFetch(cartJsUrl(), {
          credentials: 'same-origin',
          cache: 'no-store',
          headers: { Accept: 'application/json' },
        })
          .then(function (response) {
            return response.json();
          })
          .then(function (cart) {
            var items = (cart && cart.items) || [];
            var decision = decideCartMutation(items, { kind: kind, body: body || {}, context: context });
            state.items = items;
            state.knownCartQty = sumSampleQty(items);
            if (!decision.allow) {
              showMessage(anchorForRefusal());
              applyInputCaps(items);
              return refusedResponse();
            }
            return originalFetch(input, init).then(function (response) {
              var copy = response.clone();
              copy
                .json()
                .then(function (data) {
                  if (data && Array.isArray(data.items)) applyInputCaps(data.items);
                  else if (decision.projected != null) {
                    state.knownCartQty = decision.projected;
                    document.dispatchEvent(
                      new CustomEvent('ark:sample-cap', { detail: { quantity: decision.projected, message: MESSAGE } })
                    );
                  }
                })
                .catch(function () {
                  if (decision.projected != null) state.knownCartQty = decision.projected;
                });
              return response;
            });
          })
          .catch(function () {
            return originalFetch(input, init);
          });
      });
    };


    document.addEventListener('cart:update', function (event) {
      var cart = event.detail && event.detail.resource;
      if (cart && Array.isArray(cart.items)) applyInputCaps(cart.items);
    });

    function refresh() {
      originalFetch(cartJsUrl(), {
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { Accept: 'application/json' },
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (cart) {
          applyInputCaps((cart && cart.items) || []);
        })
        .catch(function () {});
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh);
    else refresh();
  }

  return {
    MAX: MAX,
    MESSAGE: MESSAGE,
    PRODUCT_ID: PRODUCT_ID,
    VARIANT_ID: VARIANT_ID,
    digits: digits,
    isSampleLine: isSampleLine,
    sumSampleQty: sumSampleQty,
    remaining: remaining,
    lineInputMax: lineInputMax,
    evaluateAdd: evaluateAdd,
    sampleQtyInAdd: sampleQtyInAdd,
    decideCartMutation: decideCartMutation,
    showMessage: function (anchor) {
      if (typeof document === 'undefined') return null;
      return showMessage(anchor);
    },
    get knownCartQty() {
      return state.knownCartQty;
    },
    install: install,
  };
});
